import './component';
import './config';
import './preview';

const { Criteria } = Shopware.Data;

Shopware.Service('cmsService').registerCmsElement({
    name: 'product-finder',
    label: 'sw-cms.elements.productFinder.label',
    component: 'sw-cms-el-product-finder',
    configComponent: 'sw-cms-el-config-product-finder',
    previewComponent: 'sw-cms-el-preview-product-finder',
    defaultConfig: {
        productFinder: {
            source: 'static',
            value: null,
            required: true,
            entity: {
                name: 'xps_product_finder',
                criteria: new Criteria()
            }
        }
    }
});